export default "__VITE_ASSET__C4Egs3Vw__"